function readStringField(source: unknown, field: string): string | null {
	if (!source || typeof source !== "object") {
		return null;
	}

	const value = (source as Record<string, unknown>)[field];
	return typeof value === "string" ? value : null;
}

function readNumberField(source: unknown, field: string): number | null {
	if (!source || typeof source !== "object") {
		return null;
	}

	const value = (source as Record<string, unknown>)[field];
	return typeof value === "number" ? value : null;
}

export function isSessionInvalidError(error: unknown): boolean {
	const status =
		readNumberField(error, "status") ??
		readNumberField(error, "statusCode") ??
		readNumberField((error as { response?: unknown })?.response, "status");

	if (status === 401 || status === 403) {
		return true;
	}

	const code = readStringField(error, "code")?.toLowerCase();
	if (
		code === "unauthorized" ||
		code === "invalid_session" ||
		code === "invalid_session_token"
	) {
		return true;
	}

	const message = readStringField(error, "message")?.toLowerCase();
	if (!message) {
		return false;
	}

	return (
		message === "unauthorized" ||
		message === "invalid session token" ||
		message.includes("session expired") ||
		message.includes("invalid session")
	);
}

export function isAuthPathname(pathname: string | null | undefined): boolean {
	return pathname === "/login" || pathname === "/signup";
}

export function getLoginRedirectPath(pathname: string | null | undefined) {
	if (!pathname || isAuthPathname(pathname)) {
		return "/login";
	}

	return `/login?returnUrl=${encodeURIComponent(pathname)}`;
}
